import {SUBDOMAIN} from "../const";

/**
 * Basis-URL des Backends für GraphQL. Nur die Stage-Hauptdomain spricht den Stage-API-Host
 * direkt an. Überall sonst bleibt die URL relativ: auf Prod und auf Tenant-Hosts leitet
 * Nginx `/graphql` weiter, lokal der Webpack-Dev-Server. Bewusst unabhängig von NODE_ENV,
 * damit der Wert nur noch den React-Modus steuert (#1187).
 */
export const getApiBaseUrl = (subdomain: string = SUBDOMAIN): string => {
    if (subdomain === "stage") {
        return "https://api.stage.kursorganizer.com";
    }

    return "";
};

/**
 * Für Ressourcen, die der Browser direkt lädt (`<img>`), am Hostnamen festgemacht:
 * `getApiBaseUrl()` liefert auf Prod "", und Nginx leitet auf dem App-Host nur `/graphql`
 * weiter, nicht `/api` (#1175).
 */
export const getPublicApiBaseUrl = (hostname: string = window.location.hostname): string => {
    if (hostname === "app.kursorganizer.com") {
        return "https://api.kursorganizer.com";
    }
    if (hostname === "stage.kursorganizer.com") {
        return "https://api.stage.kursorganizer.com";
    }

    return getApiBaseUrl(hostname.split(".")[0]);
};

/** Öffentliches, verkleinertes Firmenlogo für die Login-Seite (#1175). */
export const getCompanyLogoUrl = (koOrganizationId: string): string => `${getPublicApiBaseUrl()}/api/public/company-logo/${koOrganizationId}`;
